export default "__VITE_ASSET__$8kygznB__"